// Component structure

// BooksAndLedgers.js               ← state + all API calls
// ├── BusinessSelector.js          ← business cards / switcher
// ├── AccountingOverview.js        ← summary/productivity strip
// ├── AccountingTabs.js            ← Ledgers / Account Groups
// ├── LedgerWorkspace.js           ← ledger presentation
// ├── LedgerRow.js                 ← individual ledger
// └── AccountGroupWorkspace.js     ← account groups later

// import React, { useEffect, useMemo, useState } from "react";
import React, { useEffect, useState } from "react";
import { caApi } from "../../../backend_urls/caApi";
import LoadingSpinner from "../../../components/loaders/LoadingSpinner";
import "../../../css/pages/ca_pages/finances/BooksAndLedgers.css";

import BusinessGrid from "./models/books_ledgers_model/BusinessGrid";
import BusinessDetailsDrawer from "./models/books_ledgers_model/BusinessDetailsDrawer";

const BooksAndLedgers = () => {
    // const [clients, setClients] = useState([]);
    const [businesses, setBusinesses] = useState([]);

    const [selectedBusiness, setSelectedBusiness] = useState(null);
    const [detailsOpen, setDetailsOpen] = useState(false);

    const [ledgers, setLedgers] = useState([]);
    const [accountGroups, setAccountGroups] = useState([]);

    const [loadingBusinesses, setLoadingBusinesses] = useState(false);
    const [loadingDetails, setLoadingDetails] = useState(false);

    const [activeTab, setActiveTab] = useState("ledgers");

    // Fetch clients and collect all business records from them
    const fetchClients = async () => {
        try {
            setLoadingBusinesses(true);

            const response = await caApi.getAllClients();
            const clientList = Array.isArray(response?.data)
                ? response.data
                : Array.isArray(response)
                    ? response
                    : [];

            // setClients(clientList);

            const allBusinesses = await Promise.all(
                clientList.map(async (client) => {
                    if (!client?.id) return [];

                    try {
                        const businessResponse = await caApi.getClientBusiness(client.id);
                        const businessList = Array.isArray(businessResponse?.data)
                            ? businessResponse.data
                            : Array.isArray(businessResponse)
                                ? businessResponse
                                : Array.isArray(businessResponse?.businesses)
                                    ? businessResponse.businesses
                                    : [];

                        return businessList;
                    } catch (error) {
                        console.error(`Error fetching businesses for client ${client.id}:`, error);
                        return [];
                    }
                })
            );

            setBusinesses(allBusinesses.flat());
        } catch (error) {
            console.error("Error fetching businesses:", error);
            // setClients([]);
            setBusinesses([]);
        } finally {
            setLoadingBusinesses(false);
        }
    };

    // CLIENTS → BUSINESSES
    // const fetchBusinesses = async () => {
    //     try {
    //         setLoadingBusinesses(true);
    //         const response = await caApi.getClientBusiness();
    //         setBusinesses(response.data || response || []);
    //     } catch (error) { console.error("Error fetching businesses:", error);
    //     } finally { setLoadingBusinesses(false); }
    // };

    // BUSINESS → LEDGERS
    const fetchLedgers = async (businessId) => {
        try {
            const response = await caApi.businessLedgers(businessId);
            console.log("caApi.businessLedgers(businessId) =>", businessId);
            console.log("caApi.businessLedgers =>", response);
            setLedgers(response.data || response || []);
        } catch (error) {
            console.error("Error fetching ledgers:", error);
            setLedgers([]);
        }
    };

    // BUSINESS → ACCOUNT GROUPS
    const fetchAccountGroups = async (businessId) => {
        try {
            const response = await caApi.businessAccountGroups(businessId);
            console.log("caApi.businessAccountGroups(businessId) =>", businessId);
            console.log("caApi.businessAccountGroups() =>", response);
            setAccountGroups(response.data || response || []);
        } catch (error) {
            console.error("Error fetching account groups:", error);
            setAccountGroups([]);
        }
    };

    // OPEN BUSINESS
    const handleOpenBusiness = async (business) => {
        setSelectedBusiness(business);
        setDetailsOpen(true);

        setActiveTab("ledgers");

        setLedgers([]);
        setAccountGroups([]);

        setLoadingDetails(true);

        try {
            await Promise.all([
                fetchLedgers(business.id),
                fetchAccountGroups(business.id),
            ]);
        } finally { setLoadingDetails(false); }
    };

    const handleCloseDetails = () => {
        setDetailsOpen(false);
        setSelectedBusiness(null);
        setLedgers([]);
        setAccountGroups([]);
    };

    // INITIAL LOAD
    useEffect(() => { fetchClients(); }, []);

    if (loadingBusinesses) { return <LoadingSpinner />; }

    return (
        <div className="books-ledgers-page">
            <div className="page-header">
                <div>
                    <div className="books-ledgers-eyebrow">
                        ACCOUNTING WORKSPACE
                    </div>
                    <h1>Books & Ledgers</h1>
                    <p>
                        Manage your clients businesses, accounts and financial structure from one workspace.
                    </p>
                </div>

                <div className="page-summary">
                    <span className="summary-number">
                        {businesses.length}
                    </span>
                    {" "}
                    <span className="summary-label">
                        Businesses
                    </span>
                </div>
            </div>

            <BusinessGrid
                businesses     = { businesses }
                onOpenBusiness = { handleOpenBusiness }
            />

            <BusinessDetailsDrawer
                open          = { detailsOpen }
                business      = { selectedBusiness }
                activeTab     = { activeTab }
                setActiveTab  = { setActiveTab }
                ledgers       = { ledgers }
                accountGroups = { accountGroups }
                loading       = { loadingDetails }
                onClose       = { handleCloseDetails }
            />
        </div>
    );
};

export default BooksAndLedgers;
